export const CREATE_TOGGLE_DATA : string = "CREATE_TOGGLE_DATA";
export const GET_TOGGLE_DATA : string = "GET_TOGGLE_DATA";
export const GET_USERID_BY_TOGGLE_DATA : string = "GET_USERID_BY_TOGGLE_DATA";
export const LOADING: string = "LOADING";

